import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import NotificationsStore from 'feedback-company-vue-components/src/stores/notificationStore';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        notifications: NotificationsStore,
    },
    state: {
        languages: [],
        languagesLoading: true,
        shopSettings: {},
        shopSettingsLoading: false,
        shopSettingsSubmitting: false,
        blockingError: {},
        formValid: false,
    },
    mutations: {
        setFormValid(state, { formValid }) {
            state.formValid = formValid;
        },
        setLanguages(state, languages) {
            state.languages = languages;
        },
        setLanguageLoading(state, languagesLoading) {
            state.languagesLoading = languagesLoading;
        },
        setSelectedLanguage(state, languageCode) {
            const targetIndex = state.languages.findIndex(
                language => language.value === languageCode,
            );
            const currentIndex = state.languages.findIndex(
                language => language.isSelected,
            );
            const target = state.languages.find(
                language => language.value === languageCode,
            );
            const current = state.languages.find(
                language => language.isSelected,
            );
            target.isSelected = true;
            Vue.set(state.languages, currentIndex, current);
            if (current) {
                current.isSelected = false;
                Vue.set(state.languages, targetIndex, target);
            }
        },
        setShopSettings(state, shopSettings) {
            state.shopSettings = shopSettings;
        },
        setShopSettingsLoading(state, shopSettingsLoading) {
            state.shopSettingsLoading = shopSettingsLoading;
        },
        setAnswer(state, data) {
            const keyPath = data.name.split('.');
            let target = state.shopSettings;
            let lastStep;
            keyPath.forEach((step, index) => {
                if (keyPath.length !== index + 1) {
                    target = target[step];
                } else {
                    lastStep = step;
                }
            });
            target[lastStep] = data.value;
        },
        setBlockingError(state, data) {
            state.blockingError = data;
        },
        setShopSettingsSubmitting(state, data) {
            state.shopSettingsSubmitting = data;
        },
    },
    actions: {
        getLanguages({ commit }) {
            commit('setLanguageLoading', true);
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/lightspeed/languages/`, {
            // axios.get('/GET_languages-singular.json', {
            // axios.get('/GET_languages.json', {
                cache: 'no-cache',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'text/plain',
                    'X-Shop-Id': new URLSearchParams(document.location.search).get(
                        'shop_id',
                    ),
                    'X-language': new URLSearchParams(document.location.search).get(
                        'language',
                    ),
                    LightspeedToken: new URLSearchParams(document.location.search).get(
                        'token',
                    ),
                },
            })
                .then((response) => {
                    let { languages } = response.data;
                    languages = languages.map(language => ({
                        displayValue: language.title,
                        value: language.code,
                    }));
                    if (languages.length === 1) languages[0].isSelected = true;
                    commit('setLanguages', languages);
                    commit('setLanguageLoading', false);
                })
                .catch((error) => {
                    if (error.response) {
                        commit('setBlockingError', {
                            enabled: true,
                            message: error.response.data.message,
                            error: error.response.data.error,
                        });
                    } else {
                        commit('setBlockingError', {
                            enabled: true,
                            message: `Something went wrong. Don't worry,
                                you can always check back later.`,
                            error,
                        });
                    }
                    commit('setLanguageLoading', false);
                });
        },
        getShop({ getters, commit }) {
            commit('setShopSettingsLoading', true);
            const shopId = new URLSearchParams(document.location.search).get(
                'shop_id',
            );
            let urlParams = new URLSearchParams(window.location.search);
            urlParams.set('config_language', getters.currentLanguage.value);
            urlParams = urlParams.toString();
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/lightspeed/configuration/${shopId}?${urlParams}`, {
            // axios.get('/GET_shopSettings.json', {
                cache: 'no-cache',
            })
                .then((response) => {
                    commit('setShopSettings', response.data);
                    commit('setShopSettingsLoading', false);
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        const shopSettingsBase = {
                            shop: {
                                shop_id: parseInt(new URLSearchParams(document.location.search).get(
                                    'shop_id',
                                ), 10),
                                cluster_id: new URLSearchParams(document.location.search).get(
                                    'cluster_id',
                                ),
                                signature: new URLSearchParams(document.location.search).get(
                                    'signature',
                                ),
                                language: new URLSearchParams(document.location.search).get(
                                    'language',
                                ),
                                timestamp: new URLSearchParams(document.location.search).get(
                                    'timestamp',
                                ),
                                token: new URLSearchParams(document.location.search).get(
                                    'token',
                                ),
                            },
                            credentials: {
                                client_secret: null,
                                client_id: null,
                            },
                            invitation: {
                                order_status: null,
                                has_reminder: true,
                                delay: {
                                    unit: null,
                                    amount: null,
                                },
                                reminder: {
                                    unit: null,
                                    amount: null,
                                },
                            },
                            widgets: {
                                enabled: true,
                                product_summary: {
                                    detail_selector: 'h1',
                                    uuid: '',
                                },
                                product_extended: {
                                    type: 'sidebar',
                                    uuid: '',
                                },
                            },
                        };
                        commit('setShopSettings', shopSettingsBase);
                    }
                    commit('setShopSettingsLoading', false);
                });
        },
        saveSettings({ state, commit, getters }) {
            if (!state.formValid) {
                commit('pushNotification', {
                    type: 'warning',
                    message: 'Form is incomplete or invalid, please check for missing values or errors.',
                });
                return;
            }
            commit('setShopSettingsSubmitting', true);
            const shopId = new URLSearchParams(document.location.search).get(
                'shop_id',
            );
            axios({
                method: 'put',
                url: `${process.env.VUE_APP_API_BASE_URL}/api/lightspeed/configuration/${shopId}?language=${getters.currentLanguage.value}`,
                data: state.shopSettings,
            })
                .then(() => {
                    commit('setShopSettingsSubmitting', false);
                    commit('pushNotification', {
                        type: 'success',
                        message: 'Successfully saved your shop settings',
                    });
                })
                .catch((error) => {
                    commit('setShopSettingsSubmitting', false);
                    const action = {};
                    if (error.response) {
                        switch (error.response.status) {
                        case 500:
                            action.type = 'error';
                            action.message = '(500) Please try again later';
                            break;
                        default:
                            action.type = 'warning';
                            action.message = `(${error.response.status}) ${error.response.data.error.message}`;
                        }
                    }
                    commit('pushNotification', action);
                });
        },
    },
    getters: {
        currentLanguage: state => state.languages.filter(language => language.isSelected)[0],
    },
});
